<template>
    <UnidadeLayout>
        <LoaderPage v-if="loadingPage" />
        <div class="tw-select-none tw-min-h-screen tw-p-6">
            <div class="tw-max-w-6xl tw-mx-auto">
                <div v-if="pollingAtivo && !pollingFinalizado" class="tw-mb-8">
                    <h1 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-900'" class="tw-text-3xl tw-font-bold tw-mb-2">
                        Aplicando Parâmetros
                    </h1>
                    <p :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-600'" class="tw-text-sm">
                        Aguarde enquanto os parâmetros são aplicados aos silos selecionados
                    </p>
                </div>
                <div v-else-if="pollingFinalizado" class="tw-mb-8 tw-flex tw-justify-between">
                    <h1 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-900'" class="tw-text-3xl tw-font-bold tw-mb-2">
                        Resumo da Replicação de Parâmetros
                    </h1>
                    <button 
                        @click="voltarDoResumo"
                        :class="theme === 'dark' 
                            ? 'tw-bg-emerald-600 hover:tw-bg-emerald-700 tw-text-white' 
                            : 'tw-bg-emerald-600 hover:tw-bg-emerald-700 tw-text-white'"
                        class="tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-rounded-lg tw-transition"
                    >
                        Voltar
                    </button>
                </div>
                <div v-else class="tw-mb-8">
                    <h1 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-900'" class="tw-text-3xl tw-font-bold tw-mb-2">
                        Replicar Parâmetros
                    </h1>
                    <p :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-600'" class="tw-text-sm">
                        Selecione os silos e parâmetros que deseja replicar
                    </p>
                </div>

                <div class="tw-flex tw-gap-6" style="height: calc(100vh - 200px);">
                    <div v-if="!pollingAtivo" class="tw-flex-1 tw-overflow-y-auto custom-scrollbar tw-pr-4">
                        <div :class="[
                            'tw-p-4 tw-rounded-xl tw-mb-6 tw-border-l-4',
                            theme === 'dark' 
                                ? 'tw-bg-emerald-500/10 tw-border-emerald-500' 
                                : 'tw-bg-emerald-50 tw-border-emerald-500'
                        ]">
                            <p :class="theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-700'" class="tw-text-sm tw-font-semibold">
                                Origem: <span class="tw-font-bold">{{ parametrosData?.siloNome }} - {{ unidadeOrigem?.nome }}</span>
                            </p>
                        </div>
                        <div v-if="unidades.length === 0" :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-500'" class="tw-text-center tw-py-8">
                            Carregando silos...
                        </div>

                        <div v-for="unidade in unidades" :key="unidade.id">
                                <div v-on:click="toggleUnidadeExpand(unidade.id)" class="hover:tw-bg-gray-400/20 tw-rounded-2xl tw-cursor-pointer tw-flex tw-items-center tw-justify-between tw-py-4">
                                    <div class="tw-flex tw-items-center tw-gap-3 tw-flex-1">
                                        <button 
                                            class="tw-p-1 tw-rounded tw-transition"
                                        >
                                            <svg class="tw-w-5 tw-h-5 tw-transition-transform" :class="expandedUnidades[unidade.id] ? 'tw-rotate-90' : ''" :style="{color: theme === 'dark' ? '#9ca3af' : '#6b7280'}" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                                            </svg>
                                        </button>
                                        <img v-if="unidade.imagem" :src="getImageUrl(unidade.imagem)" class="tw-w-8 tw-h-8 tw-rounded-lg tw-object-cover" />
                                        <h3 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-900'" class="tw-font-semibold">
                                            {{ unidade.nome }}
                                        </h3>
                                    </div>
                                </div>
                                <div v-if="expandedUnidades[unidade.id]">
                                    <div v-if="loadingUnidades[unidade.id]" :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-500'" class="tw-text-center tw-py-6">
                                        <div class="tw-inline-block tw-animate-spin tw-rounded-full tw-h-5 tw-w-5" :class="theme === 'dark' ? 'tw-border-gray-600 tw-border-t-gray-300' : 'tw-border-gray-300 tw-border-t-gray-600'"></div>
                                        <p class="tw-mt-2 tw-text-sm">Carregando silos...</p>
                                    </div>
                                    <div v-else-if="getSilosFromUnidade(unidade.id).length === 0" :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-500'" class="tw-text-center tw-py-6 tw-text-sm">
                                        Nenhum silo disponível
                                    </div>
                                    <div v-else>
                                        <label class="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-my-3">
                                            <input 
                                                type="checkbox" 
                                                :checked="isUnidadeFullySelected(unidade.id)"
                                                @change="toggleUnidade(unidade.id)"
                                                class="tw-rounded tw-w-4 tw-h-4 tw-accent-emerald-500"
                                            />
                                            <span :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-700'" class="tw-text-sm tw-font-medium">
                                                Selecionar Todos
                                            </span>
                                        </label>
                                        <div class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-2 tw-mb-4">
                                            <div 
                                                v-for="silo in getSilosFromUnidade(unidade.id)" 
                                                :key="silo.id" 
                                                @click="toggleSilo(silo.id)"
                                                :class="[
                                                    selectedSilos.includes(silo.id) 
                                                        ? 'tw-bg-emerald-500 tw-text-white'
                                                        : (theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-400' : 'tw-bg-gray-100 tw-text-gray-600'),
                                                    silo.id === siloOrigem ? 'tw-bg-gray-400/70 tw-cursor-not-allowed' : 'tw-cursor-pointer',
                                                    'tw-flex-1 tw-px-3 tw-py-3 tw-rounded-lg tw-text-xs tw-font-semibold tw-text-center'
                                                ]">
                                                <div class="tw-font-medium">{{ silo.nome }}</div>
                                            </div>
                                        </div>
                                    </div>  
                                </div>
                        </div>
                    </div>
                    <div v-if="pollingAtivo && !pollingFinalizado" class="tw-flex-1 tw-overflow-y-auto custom-scrollbar tw-pr-4">
                        <div class="tw-space-y-4">
                            <div 
                                v-for="item in pollingStatus" 
                                :key="`${item.unidade_id}-${item.silo_id}`"
                                :class="[
                                    'tw-p-4 tw-rounded-lg tw-transition-all tw-duration-300',
                                    item.status === 'processed'
                                        ? (theme === 'dark' 
                                            ? 'tw-bg-green-500/10' 
                                            : 'tw-bg-green-50')
                                        : item.status === 'error'
                                        ? (theme === 'dark'
                                            ? 'tw-bg-red-500/10'
                                            : 'tw-bg-red-50')
                                        : (theme === 'dark' 
                                            ? 'tw-bg-slate-800/50' 
                                            : 'tw-bg-gray-50')
                                ]">
                                <div class="tw-flex tw-items-center tw-gap-4 tw-justify-between">
                                    <div class="tw-flex tw-items-center tw-gap-4 tw-flex-1">
                                        <div>
                                            <div v-if="item.status === 'processing'" class="tw-inline-block tw-animate-spin tw-rounded-full tw-h-6 tw-w-6" :class="theme === 'dark' ? 'tw-border-2 tw-border-slate-600 tw-border-t-slate-300' : 'tw-border-2 tw-border-gray-300 tw-border-t-gray-600'"></div>
                                            <div v-else-if="item.status === 'processed'" class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-green-500 tw-flex tw-items-center tw-justify-center">
                                                <svg class="tw-w-4 tw-h-4 tw-text-white" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                                </svg>
                                            </div>
                                            <div v-else class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-red-500 tw-flex tw-items-center tw-justify-center">
                                                <svg class="tw-w-4 tw-h-4 tw-text-white" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div>
                                            <p :class="[
                                                'tw-font-semibold',
                                                item.status === 'processed'
                                                    ? (theme === 'dark' ? 'tw-text-green-400' : 'tw-text-green-700')
                                                    : item.status === 'error'
                                                    ? (theme === 'dark' ? 'tw-text-red-400' : 'tw-text-red-700')
                                                    : (theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-gray-700')
                                            ]">
                                                {{ getSiloNome(item.silo_id) }}
                                            </p>
                                            <p :class="[
                                                'tw-text-sm',
                                                item.status === 'processed'
                                                    ? (theme === 'dark' ? 'tw-text-green-500' : 'tw-text-green-600')
                                                    : item.status === 'error'
                                                    ? (theme === 'dark' ? 'tw-text-red-400' : 'tw-text-red-600')
                                                    : (theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-gray-600')
                                            ]">
                                                {{ getUnidadeNome(item.unidade_id) }} • 
                                                <span v-if="item.status === 'processed'">Concluído</span>
                                                <span v-else-if="item.status === 'error'">Erro - Unidade não recebeu os dados</span>
                                                <span v-else>Processando...</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div :class="[
                                        'tw-text-sm tw-font-medium tw-px-3 tw-py-1 tw-rounded-full',
                                        item.status === 'processed'
                                            ? (theme === 'dark' 
                                                ? 'tw-bg-green-500/20 tw-text-green-400' 
                                                : 'tw-bg-green-100 tw-text-green-700')
                                            : item.status === 'error'
                                            ? (theme === 'dark'
                                                ? 'tw-bg-red-500/20 tw-text-red-400'
                                                : 'tw-bg-red-100 tw-text-red-700')
                                            : (theme === 'dark' 
                                                ? 'tw-bg-slate-600/30 tw-text-slate-400' 
                                                : 'tw-bg-gray-200 tw-text-gray-600')
                                    ]">
                                        <span v-if="item.status === 'processed'">Processado</span>
                                        <span v-else-if="item.status === 'error'">Erro</span>
                                        <span v-else>Processando</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="pollingFinalizado" class="tw-flex-1 tw-overflow-y-auto custom-scrollbar tw-pr-4">
                        <div class="tw-space-y-4">
                            <div class="tw-mb-6">
                                <div class="tw-flex tw-items-center tw-gap-3 tw-mb-4">
                                    <svg v-if="pollingStatus.some(item => item.status === 'error')" class="tw-w-8 tw-h-8 tw-text-red-500" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                                    </svg>
                                    <svg v-else class="tw-w-8 tw-h-8 tw-text-green-500" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                                    </svg>
                                    <h2 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-900'" class="tw-text-2xl tw-font-bold">
                                        {{ pollingStatus.some(item => item.status === 'error') ? 'Replicação Concluída com Erros' : 'Replicação Concluída!' }}
                                    </h2>
                                </div>
                                <div v-if="pollingStatus.filter(item => item.status === 'processed').length > 0" :class="[theme === 'dark' ? 'tw-bg-green-500/10 tw-text-green-400' : 'tw-bg-green-50 tw-text-green-700', 'tw-p-4 tw-rounded-lg tw-mb-4']"> 
                                    <p class="tw-font-semibold">{{ pollingStatus.filter(item => item.status === 'processed').length }} silo(s) atualizado(s) com sucesso</p>
                                </div>
                                <div v-if="pollingStatus.filter(item => item.status === 'error').length > 0" :class="[theme === 'dark' ? 'tw-bg-red-500/10 tw-text-red-400' : 'tw-bg-red-50 tw-text-red-700', 'tw-p-4 tw-rounded-lg']"> 
                                    <p class="tw-font-semibold">{{ pollingStatus.filter(item => item.status === 'error').length }} silo(s) não conseguiu atualizar</p>
                                </div>
                            </div>
                            <div>
                                <h3 :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-600'" class="tw-text-sm tw-font-semibold tw-uppercase tw-mb-3 tw-tracking-wide">Detalhes</h3>
                                <div class="tw-space-y-3">
                                    <div 
                                        v-for="item in pollingStatus" 
                                        :key="`${item.unidade_id}-${item.silo_id}`"
                                        :class="[
                                            'tw-p-4 tw-rounded-lg tw-transition',
                                            item.status === 'processed'
                                                ? (theme === 'dark' 
                                                    ? 'tw-bg-green-500/10' 
                                                    : 'tw-bg-green-50')
                                                : (theme === 'dark'
                                                    ? 'tw-bg-red-500/10'
                                                    : 'tw-bg-red-50')
                                        ]">
                                        <div class="tw-flex tw-items-center tw-gap-3">
                                            <div>
                                                <div v-if="item.status === 'processed'" class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-green-500 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                                                    <svg class="tw-w-4 tw-h-4 tw-text-white" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                                    </svg>
                                                </div>
                                                <div v-else class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-red-500 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                                                    <svg class="tw-w-4 tw-h-4 tw-text-white" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="tw-flex-1">
                                                <p :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-900'" class="tw-font-semibold">
                                                    {{ getSiloNome(item.silo_id) }}
                                                </p>
                                                <p :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-600'" class="tw-text-sm">
                                                    {{ getUnidadeNome(item.unidade_id) }}
                                                </p>
                                                <p v-if="item.status === 'error'" :class="theme === 'dark' ? 'tw-text-red-400' : 'tw-text-red-600'" class="tw-text-xs tw-mt-1">
                                                    Erro - A unidade não recebeu os dados no tempo esperado. Se persistir, entre em contato com o suporte.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!pollingAtivo" class="tw-flex-1 tw-flex-shrink-0 tw-sticky" style="top: 120px;">
                        <div :class="[
                            'tw-shadow-lg tw-rounded-xl tw-p-6 tw-flex tw-flex-col',
                            theme === 'dark' 
                                ? 'tw-bg-[#1a1d21]' 
                                : 'tw-bg-white'
                        ]">
                            <h2 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-900'" class="tw-font-semibold tw-text-sm tw-mb-4 tw-uppercase tw-tracking-wide tw-flex-shrink-0">
                                Parâmetros
                            </h2>

                            <div>
                                <div class="tw-grid tw-grid-cols-2 tw-gap-3">
                                    <label :class="[
                                        'tw-p-3 tw-rounded-lg tw-cursor-pointer tw-flex tw-items-center tw-gap-3',
                                        selectedParameters.includes('programa_selecionado')
                                            ? (theme === 'dark' ? 'tw-bg-[#334155]' : 'tw-bg-emerald-50')
                                            : (theme === 'dark' ? 'tw-bg-slate-800/30' : 'tw-bg-gray-50')
                                    ]">
                                        <input 
                                            v-model="selectedParameters"
                                            value="programa_selecionado"
                                            type="checkbox"
                                            class="tw-rounded tw-w-4 tw-h-4 tw-accent-emerald-500 tw-flex-shrink-0"
                                        />
                                        <div class="tw-flex-1 tw-min-w-0">
                                            <p :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-800'" class="tw-text-sm tw-font-medium tw-truncate">
                                                Programa selecionado
                                            </p>
                                            <p :class="theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-600'" class="tw-text-xs tw-font-semibold tw-mt-1">
                                                {{ programaSelecionadoNome }}
                                            </p>
                                        </div>
                                    </label>
                                    <label :class="[
                                        'tw-p-3 tw-rounded-lg tw-cursor-pointer tw-flex tw-items-center tw-gap-3',
                                        selectedParameters.includes('1')
                                            ? (theme === 'dark' ? 'tw-bg-[#334155]' : 'tw-bg-emerald-50')
                                            : (theme === 'dark' ? 'tw-bg-slate-800/30' : 'tw-bg-gray-50')
                                    ]">
                                        <input 
                                            v-model="selectedParameters"
                                            value="1"
                                            type="checkbox"
                                            class="tw-rounded tw-w-4 tw-h-4 tw-accent-emerald-500 tw-flex-shrink-0"
                                        />
                                        <div class="tw-flex-1 tw-min-w-0">
                                            <p :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-800'" class="tw-text-sm tw-font-medium tw-truncate">
                                                Programa Livre
                                            </p>
                                            <p :class="theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-600'" class="tw-text-xs tw-font-semibold tw-mt-1">
                                                {{
                                                    (() => {
                                                        const programa = parametrosData?.parametros?.find(p => p.programa_id === 1)
                                                        return programa
                                                            ? `${programa.temperatura_minima}° - ${programa.temperatura_maxima}° / ${programa.umidade_minima}% - ${programa.umidade_maxima}%`
                                                            : 'N/A'
                                                    })()
                                                }}
                                            </p>
                                        </div>
                                    </label>
                                    <label :class="[
                                        'tw-p-3 tw-rounded-lg tw-cursor-pointer tw-flex tw-items-center tw-gap-3',
                                        selectedParameters.includes('2')
                                            ? (theme === 'dark' ? 'tw-bg-[#334155]' : 'tw-bg-emerald-50')
                                            : (theme === 'dark' ? 'tw-bg-slate-800/30' : 'tw-bg-gray-50')
                                    ]">
                                        <input 
                                            v-model="selectedParameters"
                                            value="2"
                                            type="checkbox"
                                            class="tw-rounded tw-w-4 tw-h-4 tw-accent-emerald-500 tw-flex-shrink-0"
                                        />
                                        <div class="tw-flex-1 tw-min-w-0">
                                            <p :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-800'" class="tw-text-sm tw-font-medium tw-truncate">
                                                Programa Temporizado
                                            </p>
                                            <p :class="theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-600'" class="tw-text-xs tw-font-semibold tw-mt-1">
                                                {{
                                                    (() => {
                                                        const programa = parametrosData?.parametros?.find(p => p.programa_id === 2)
                                                        return programa
                                                            ? `${programa.temperatura_minima}° - ${programa.temperatura_maxima}° / ${programa.umidade_minima}% - ${programa.umidade_maxima}% / ${programa.horario_inicio} - ${programa.horario_final}`
                                                            : 'N/A'
                                                    })()
                                                }}
                                            </p>
                                        </div>
                                    </label>
                                    <label :class="[
                                        'tw-p-3 tw-rounded-lg tw-cursor-pointer tw-flex tw-items-center tw-gap-3',
                                        selectedParameters.includes('3')
                                            ? (theme === 'dark' ? 'tw-bg-[#334155]' : 'tw-bg-emerald-50')
                                            : (theme === 'dark' ? 'tw-bg-slate-800/30' : 'tw-bg-gray-50')
                                    ]">
                                        <input 
                                            v-model="selectedParameters"
                                            value="3"
                                            type="checkbox"
                                            class="tw-rounded tw-w-4 tw-h-4 tw-accent-emerald-500 tw-flex-shrink-0"
                                        />
                                        <div class="tw-flex-1 tw-min-w-0">
                                            <p :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-800'" class="tw-text-sm tw-font-medium tw-truncate">
                                                Equilíbrio Higroscópico
                                            </p>
                                            <p :class="theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-600'" class="tw-text-xs tw-font-semibold tw-mt-1">
                                                {{
                                                    (() => {
                                                        const programa = parametrosData?.parametros?.find(p => p.programa_id === 3)
                                                        return programa
                                                            ? `${programa.umidade_minima}% - ${programa.umidade_maxima}%`
                                                            : 'N/A'
                                                    })()
                                                }}
                                            </p>
                                        </div>
                                    </label>
                                    <label :class="[
                                        'tw-p-3 tw-rounded-lg tw-cursor-pointer tw-flex tw-items-center tw-gap-3',
                                        selectedParameters.includes('modo_operacao')
                                            ? (theme === 'dark' ? 'tw-bg-[#334155]' : 'tw-bg-emerald-50')
                                            : (theme === 'dark' ? 'tw-bg-slate-800/30' : 'tw-bg-gray-50')
                                    ]">
                                        <input 
                                            v-model="selectedParameters"
                                            value="modo_operacao"
                                            type="checkbox"
                                            class="tw-rounded tw-w-4 tw-h-4 tw-accent-emerald-500 tw-flex-shrink-0"
                                        />
                                        <div class="tw-flex-1 tw-min-w-0">
                                            <p :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-800'" class="tw-text-sm tw-font-medium tw-truncate">
                                                Modo de Operação
                                            </p>
                                            <p :class="theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-600'" class="tw-text-xs tw-font-semibold tw-mt-1">
                                                {{ parametrosData?.aeracao?.modo_operacao === 1 ? 'Automático' : 'Manual' }}
                                            </p>
                                        </div>
                                    </label>
                                    <label :class="[
                                        'tw-p-3 tw-rounded-lg tw-cursor-pointer tw-flex tw-items-center tw-gap-3',
                                        selectedParameters.includes('status_aeracao')
                                            ? (theme === 'dark' ? 'tw-bg-[#334155]' : 'tw-bg-emerald-50')
                                            : (theme === 'dark' ? 'tw-bg-slate-800/30' : 'tw-bg-gray-50')
                                    ]">
                                        <input 
                                            v-model="selectedParameters"
                                            value="status_aeracao"
                                            type="checkbox"
                                            class="tw-rounded tw-w-4 tw-h-4 tw-accent-emerald-500 tw-flex-shrink-0"
                                        />
                                        <div class="tw-flex-1 tw-min-w-0">
                                            <p :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-800'" class="tw-text-sm tw-font-medium tw-truncate">
                                                Aeração
                                            </p>
                                            <p :class="theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-600'" class="tw-text-xs tw-font-semibold tw-mt-1">
                                                {{ parametrosData?.aeracao?.aeracao ? 'Liberada' : 'Bloqueada' }}
                                            </p>
                                        </div>
                                    </label>
                                    <label :class="[
                                        'tw-p-3 tw-rounded-lg tw-cursor-pointer tw-flex tw-items-center tw-gap-3',
                                        selectedParameters.includes('produto')
                                            ? (theme === 'dark' ? 'tw-bg-[#334155]' : 'tw-bg-emerald-50')
                                            : (theme === 'dark' ? 'tw-bg-slate-800/30' : 'tw-bg-gray-50')
                                    ]">
                                        <input 
                                            v-model="selectedParameters"
                                            value="produto"
                                            type="checkbox"
                                            class="tw-rounded tw-w-4 tw-h-4 tw-accent-emerald-500 tw-flex-shrink-0"
                                        />
                                        <div class="tw-flex-1 tw-min-w-0">
                                            <p :class="theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-800'" class="tw-text-sm tw-font-medium tw-truncate">
                                                Produto
                                            </p>
                                            <p :class="theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-600'" class="tw-text-xs tw-font-semibold tw-mt-1">
                                                {{ produtoDesc }}
                                            </p>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <div class="tw-my-4 tw-border-t tw-flex-shrink-0" :class="theme === 'dark' ? 'tw-border-gray-700' : 'tw-border-gray-200'"></div>
                            <div class="tw-flex-shrink-0 tw-mb-4">
                                <p :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-500'" class="tw-text-xs tw-font-semibold tw-uppercase tw-mb-3">
                                    Resumo
                                </p>
                                <div class="tw-flex tw-gap-4">
                                    <div>
                                        <p :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-600'" class="tw-text-xs">
                                            Silos
                                        </p>
                                        <p :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-900'" class="tw-text-lg tw-font-bold tw-text-emerald-500">
                                            {{ selectedSilos.length }}
                                        </p>
                                    </div>
                                    <div>
                                        <p :class="theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-600'" class="tw-text-xs">
                                            Parâmetros
                                        </p>
                                        <p :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-900'" class="tw-text-lg tw-font-bold tw-text-emerald-500">
                                            {{ selectedParameters.length }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="tw-flex tw-gap-2 tw-flex-shrink-0">
                                <button 
                                    @click="voltar"
                                    :class="theme === 'dark' ? 'tw-bg-gray-800 tw-text-gray-300 hover:tw-bg-gray-700' : 'tw-bg-gray-200 tw-text-gray-700 hover:tw-bg-gray-300'"
                                    class="tw-flex-1 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-rounded-lg tw-transition"
                                >
                                    Cancelar
                                </button>
                                <button 
                                    @click="replicarParametros"
                                    :disabled="selectedSilos.length === 0 || selectedParameters.length === 0 || replicandoParametros"
                                    :class="[
                                        'tw-flex-1 tw-px-4 tw-py-2 tw-text-white tw-text-sm tw-font-semibold tw-rounded-lg disabled:tw-opacity-50 disabled:tw-cursor-not-allowed',
                                        theme === 'dark' 
                                            ? 'tw-bg-emerald-600 hover:tw-bg-emerald-700' 
                                            : 'tw-bg-emerald-600 hover:tw-bg-emerald-700'
                                    ]"
                                >
                                    <span v-if="!replicandoParametros">Replicar</span>
                                    <span v-else>Replicando...</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </UnidadeLayout>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import UnidadeLayout from "@/components/layouts/v2/UnidadeLayout.vue";
import LoaderPage from '@/components/ui/v2/LoaderPage.vue';

export default {
    components: {
        UnidadeLayout,
        LoaderPage
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const toast = useToast();

        const unidades = ref([]);
        const selectedSilos = ref([]);
        const selectedParameters = ref(['programa_selecionado', '1', '2', '3', 'modo_operacao', 'status_aeracao', 'produto']);
        const parametrosData = ref(null);
        const loadingPage = ref(true);
        const replicandoParametros = ref(false);
        const expandedUnidades = ref({});
        const loadingUnidades = ref({});
        const siloOrigem = ref(null);
        const unidadeOrigem = ref(null);
        const programaSelecionadoNome = ref('');
        const produtoDesc = ref('');
        const pollingAtivo = ref(false);
        const pollingFinalizado = ref(false);
        const pollingStatus = ref([]);
        let pollingInterval = null;

        const theme = computed(() => store.state.ui.theme);

        onMounted(async () => {
            try {
                loadingPage.value = true;
                const parametrosJson = sessionStorage.getItem('parametrosParaReplicar');
                if (!parametrosJson) {
                    toast.error('Nenhum parâmetro foi selecionado');
                    router.back();
                    return;
                }

                parametrosData.value = JSON.parse(parametrosJson);
                siloOrigem.value = parametrosData.value.siloOrigem;
                const unidadeOrigemId = parametrosData.value.unidadeId;
                const todasUnidades = store.state.unidades.unidades.filter(u => u.status === 'ativo' && u.permissoes && u.permissoes.parametrizacao_aeracao_silo !== 0);
                todasUnidades.forEach(unidade => {
                    unidade.silos = [];
                });
                unidades.value = todasUnidades;
                unidadeOrigem.value = unidades.value.find(u => u.id === parseInt(unidadeOrigemId));
                await toggleUnidadeExpand(unidadeOrigemId);
                if (!selectedSilos.value.includes(siloOrigem.value)) {
                    selectedSilos.value.push(siloOrigem.value);
                }
                let programasDesc = [
                    { id: 1, nome: 'Programa Livre' },
                    { id: 2, nome: 'Programa Livre Temporizado' },
                    { id: 3, nome: 'Equilíbrio Higroscópico' },
                    { id: 4, nome: 'Programa Curva 1' },
                    { id: 5, nome: 'Programa Curva 2' },
                    { id: 6, nome: 'Programa Curva 3' },
                    { id: 7, nome: 'Programa Curva 4' },
                    { id: 8, nome: 'Programa Personalizado' }
                ]
                 const produtos = {
                    1: "Vazio",
                    2: "Cevada",
                    3: "Feijão",
                    4: "Milho",
                    5: "Arroz",
                    6: "Sorgo",
                    7: "Soja",
                    8: "Trigo",
                    9: "Canola",
                    10: "Azevém",
                    11: "Linhaça",
                    12: "Painço",
                    13: "Alpiste",
                    14: "Milheto",
                    15: "Aveia",
                    16: "Girassol",
                    17: "Outro",
                };
                produtoDesc.value = produtos[parametrosData.value.aeracao?.produto] || 'N/A';
                const programaSelecionado = programasDesc.find(p => p.id === parametrosData.value.aeracao?.programa);
                programaSelecionadoNome.value = programaSelecionado ? programaSelecionado.nome : 'N/A';
                
                loadingPage.value = false;
            } catch (error) {
                console.error('Erro ao carregar dados:', error);
                toast.error('Erro ao carregar dados');
                loadingPage.value = false;
            }
        });

        const toggleUnidadeExpand = async (unidadeId) => {
            const isExpanded = expandedUnidades.value[unidadeId];
            
            if (isExpanded) {
                expandedUnidades.value[unidadeId] = false;
            } else {
                loadingUnidades.value[unidadeId] = true;
                try {
                    const unidade = unidades.value.find(u => u.id === parseInt(unidadeId));
                    if (unidade && unidade.silos.length === 0) {
                        unidade.silos = await store.dispatch("silos/fetchSilosByUnidadeNoStore", unidadeId);
                    }
                    expandedUnidades.value[unidadeId] = true;
                } catch (error) {
                    console.error(`Erro ao carregar silos da unidade ${unidadeId}:`, error);
                    toast.error('Erro ao carregar silos');
                } finally {
                    loadingUnidades.value[unidadeId] = false;
                }
            }
        };

        const getSilosFromUnidade = (unidadeId) => {
            const unidade = unidades.value.find(u => u.id === unidadeId);
            return unidade?.silos || [];
        };

        const isUnidadeFullySelected = (unidadeId) => {
            const silos = getSilosFromUnidade(unidadeId);
            if (silos.length === 0) return false;
            return silos.every(silo => selectedSilos.value.includes(silo.id));
        };

        const toggleUnidade = (unidadeId) => {
            const silos = getSilosFromUnidade(unidadeId);
            const allSelected = isUnidadeFullySelected(unidadeId);

            if (allSelected) {
                selectedSilos.value = selectedSilos.value.filter(
                    id => siloOrigem.value === id || !silos.some(silo => silo.id === id)
                );
            } else {
                const idsToAdd = silos.map(silo => silo.id).filter(id => !selectedSilos.value.includes(id));
                selectedSilos.value.push(...idsToAdd);
            }
        };

        const toggleSilo = (siloId) => {
            if (siloId === siloOrigem.value) {
                return;
            }
            
            const index = selectedSilos.value.indexOf(siloId);
            if (index > -1) {
                selectedSilos.value.splice(index, 1);
            } else {
                selectedSilos.value.push(siloId);
            }
        };

        const getImageUrl = (path) => {
            return path ? `${process.env.VUE_APP_SERVER}/storage/${path}` : '';
        };

        const getSiloNome = (siloId) => {
            for (const unidade of unidades.value) {
                const silo = unidade.silos?.find(s => s.id === siloId);
                if (silo) return silo.nome;
            }
            return `Silo ${siloId}`;
        };

        const getUnidadeNome = (unidadeId) => {
            const unidade = unidades.value.find(u => u.id === unidadeId);
            return unidade?.nome || `Unidade ${unidadeId}`;
        };

        const voltar = () => {
            sessionStorage.removeItem('parametrosParaReplicar');
            router.back();
        };

        const voltarDoResumo = () => {
            pollingFinalizado.value = false;
            pollingAtivo.value = false;
            pollingStatus.value = [];
            if (pollingInterval) clearInterval(pollingInterval);
            voltar();
        };

        const pollBatchStatus = async (batchId) => {
            try {
                const now = Date.now();
                const response = await store.dispatch('silos/getBatchStatus', batchId);
                
                let hasTimeout = false;
                pollingStatus.value.forEach(item => {
                    const timeElapsed = now - item.startTime;
                    if (timeElapsed > 10000 && item.status === 'processing') {
                        item.status = 'error';
                        hasTimeout = true;
                    }
                });
                
                if (response.data?.messages) {
                    const messagesByKey = {};
                    response.data.messages.forEach(message => {
                        const key = `${message.unidade_id}-${message.silo_id}`;
                        if (!messagesByKey[key]) {
                            messagesByKey[key] = [];
                        }
                        messagesByKey[key].push(message);
                    });

                    pollingStatus.value.forEach(item => {
                        const key = `${item.unidade_id}-${item.silo_id}`;
                        const messages = messagesByKey[key] || [];
                        
                        const allProcessed = messages.length > 0 && messages.every(msg => msg.status === 'processed');
                        if (allProcessed) {
                            item.status = 'processed';
                        }
                    });
                }

                const allFinished = pollingStatus.value.every(item => item.status === 'processed' || item.status === 'error');
                
                if (allFinished || hasTimeout) {
                    if (pollingInterval) clearInterval(pollingInterval);
                    pollingFinalizado.value = true;
                    
                    if (pollingStatus.value.some(item => item.status === 'error')) {
                        toast.warning('Alguns silos não foram atualizados no tempo limite');
                    } else {
                        toast.success('Parâmetros aplicados com sucesso!');
                    }
                }
            } catch (error) {
                console.error('Erro ao buscar status do lote:', error);
            }
        };

        const getSiloUnidadeMapping = () => {
            const mapping = {};
            unidades.value.forEach(unidade => {
                if (unidade.silos) {
                    unidade.silos.forEach(silo => {
                        mapping[silo.id] = unidade.id;
                    });
                }
            });
            return mapping;
        };

        const replicarParametros = async () => {
            if (selectedSilos.value.length === 0 || selectedParameters.value.length === 0) {
                toast.warning('Selecione pelo menos um silo e um parâmetro');
                return;
            }

            try {
                replicandoParametros.value = true;
                const aeracaoParaReplicar = {};

                aeracaoParaReplicar.modo_operacao = (
                    selectedParameters.value.includes('modo_operacao')
                    ? parametrosData.value.aeracao?.modo_operacao 
                    : null
                );
                aeracaoParaReplicar.aeracao = (
                    selectedParameters.value.includes('status_aeracao')
                    ? parametrosData.value.aeracao?.aeracao 
                    : null
                );
                aeracaoParaReplicar.produto = (
                    selectedParameters.value.includes('produto') 
                    ? parametrosData.value.aeracao?.produto 
                    : null
                );
                aeracaoParaReplicar.programa = (
                    selectedParameters.value.includes('programa_selecionado')
                    ? parametrosData.value.aeracao?.programa 
                    : null
                );

                const parametrosParaReplicar = parametrosData.value.parametros.filter(p =>
                    selectedParameters.value.includes(String(p.programa_id))
                );

                let params = {
                    silosIds: selectedSilos.value,
                    aeracao: aeracaoParaReplicar,
                    parametros: parametrosParaReplicar
                };

                const response = await store.dispatch('silos/updateSilosEmLote', {params});

                const siloUnidadeMapping = getSiloUnidadeMapping();
                const now = Date.now();
                pollingStatus.value = selectedSilos.value.map(siloId => ({
                    silo_id: siloId,
                    unidade_id: siloUnidadeMapping[siloId] || unidadeOrigem.value.id,
                    status: 'processing',
                    startTime: now
                }));

                pollingAtivo.value = true;
                
                pollingInterval = setInterval(() => {
                    pollBatchStatus(response.data.batch_id);
                }, 1000);

            } catch (error) {
                console.error('Erro ao aplicar parâmetros:', error);
                toast.error('Erro ao aplicar parâmetros');
            } finally {
                replicandoParametros.value = false;
            }
        };

        return {
            unidades,
            selectedSilos,
            selectedParameters,
            parametrosData,
            loadingPage,
            replicandoParametros,
            expandedUnidades,
            loadingUnidades,
            siloOrigem,
            theme,
            getSilosFromUnidade,
            isUnidadeFullySelected,
            toggleUnidade,
            toggleSilo,
            toggleUnidadeExpand,
            getImageUrl,
            voltar,
            voltarDoResumo,
            replicarParametros,
            unidadeOrigem,
            programaSelecionadoNome,
            produtoDesc,
            pollingAtivo,
            pollingFinalizado,
            pollingStatus,
            pollBatchStatus,
            getSiloNome,
            getUnidadeNome
        };
    }
};
</script>
